import { render, staticRenderFns } from "./productlineOfCustomer.vue?vue&type=template&id=4f5a99ab&scoped=true&"
import script from "./productlineOfCustomer.vue?vue&type=script&lang=js&"
export * from "./productlineOfCustomer.vue?vue&type=script&lang=js&"
import style0 from "./productlineOfCustomer.vue?vue&type=style&index=0&id=4f5a99ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5a99ab",
  null
  
)

export default component.exports